import { render, staticRenderFns } from "./EditGuestAllocation.vue?vue&type=template&id=69205a36&scoped=true&"
import script from "./EditGuestAllocation.vue?vue&type=script&lang=js&"
export * from "./EditGuestAllocation.vue?vue&type=script&lang=js&"
import style0 from "./EditGuestAllocation.vue?vue&type=style&index=0&id=69205a36&lang=scss&scoped=true&"
import style1 from "./EditGuestAllocation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69205a36",
  null
  
)

export default component.exports